import React from 'react';
import { Spin } from 'antd';
import './style.css';
import useLoading from './useLoading';

const LoadingMark: React.FC = () => {
  const {loading, message} = useLoading((state) => state);

  if (!loading) return null;

  return (
    <div className="loading-overlay">
      <Spin size="large" tip={message} spinning={true}/>
    </div>
  );
};

export default LoadingMark;
